import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "elevation-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_raster_s_v_g_layer = _resolveComponent("raster-s-v-g-layer")!
  const _component_map_marker = _resolveComponent("map-marker")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_shared_map = _resolveComponent("shared-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_shared_map, {
      "drawing-tool-cursor": _ctx.drawingToolCursor,
      onClick: _ctx.handleMapClick,
      onLMapReady: _ctx.setLMap,
      onZoomLevelChanged: _ctx.updateZoomLevel
    }, {
      map: _withCtx(() => [
        (_ctx.lMap !== null && _ctx.rasterDatasetStore.hasLoaded)
          ? (_openBlock(), _createBlock(_component_raster_s_v_g_layer, {
              key: 0,
              map: _ctx.lMap,
              bbox: _ctx.rasterDatasetStore.metadata?.bboxOuter,
              "grid-bounds": _ctx.rasterDatasetStore.metadata?.gridBounds,
              "raster-step": _ctx.rasterDatasetStore.metadata?.spatialResolution,
              crs: _ctx.rasterDatasetStore.metadata?.crs,
              "current-zoom": _ctx.currentZoom
            }, null, 8, ["map", "bbox", "grid-bounds", "raster-step", "crs", "current-zoom"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.timeseriesStore.activeCoords), ([id, coord]) => {
          return (_openBlock(), _createBlock(_component_map_marker, {
            key: id,
            "scale-factor": _ctx.timeseriesStore.highlightedCoordID === id ? 1.5 : 1,
            "lat-lng": coord,
            icon: "blue",
            animation: "bounce",
            onClick: () => _ctx.handleMarkerClick(id)
          }, null, 8, ["scale-factor", "lat-lng", "onClick"]))
        }), 128))
      ]),
      tools: _withCtx(() => [
        _createVNode(_component_v_tooltip, {
          text: _ctx.t('raster.tooltip.reset_coordinates'),
          bottom: "",
          "open-delay": 200
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, {
              class: 'ml-4 delete-button zamg-button-outline-primary',
              "data-testid": "map-reset-all-coordinates",
              variant: "outlined",
              elevation: "2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.timeseriesStore.resetCoords()))
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { color: "primary" }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" mdi-delete-outline ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 8, ["text"]),
        _createVNode(_component_v_tooltip, {
          text: _ctx.t('raster.tooltip.select_timeseries_on_map'),
          bottom: "",
          "open-delay": 200
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, {
              "data-testid": "map-add-marker",
              class: ["ml-4 zamg-button-outline-primary", [_ctx.toolIsActive ? 'active-button' : '']],
              "min-width": "30px",
              width: "30px",
              height: "32px",
              onClick: _cache[1] || (_cache[1] = () => (_ctx.toolIsActive = !_ctx.toolIsActive))
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "custom:zamgPin",
                  color: "primary"
                })
              ]),
              _: 1
            }, 16, ["class"])
          ]),
          _: 1
        }, 8, ["text"])
      ]),
      _: 1
    }, 8, ["drawing-tool-cursor", "onClick", "onLMapReady", "onZoomLevelChanged"])
  ]))
}